import { isCorpTenant } from "@capone/common";
import { config } from "../../../api/config";

export const CONFIRM_AND_BOOK = "Confirm and book";

export const PRODUCT_NAME = () => {
  if (!isCorpTenant(config.TENANT)) {
    return "package";
  }
  return "hotel + flight";
};
